import React from 'react';
import { cn } from '@express-labs/raven-tools';
import {
  ButtonBack,
  ButtonNext,
  CarouselProvider,
  Slider,
} from 'pure-react-carousel';
import IconLeft from '../IconLeft';
import IconRight from '../IconRight';
import ImageWatcher from '../ImageWatcher';
import s from '../../Carousel.scss';
import styles from './CarouselOutfits.scss';
import RenderSlideOutfits from '../RenderSlideOutfits';

export type CarouselOutfitsProps = {
  cards?: never;
  /** array of image url strings */
  ariaLabelItems?: string[];
  currentSlide?: number;
  largeImages?: string[];
  /** array of image url strings */
  mainImages?: string[];
  /** Moves the nth slide into the leftmost position of the carousel */
  onModelImages?: boolean[];
  selectedItem?: number;
  visibleSlides?: number;
};

type PropsInjectedByCarousel = {
  onClick: (i: number, ev: React.MouseEvent<HTMLElement>) => void;
  onKeyDown: (i: number, ev: React.KeyboardEvent<HTMLElement>) => void;
  /**  a unique id for the carousel. This number is used to help create unique css id's and class
  names so that you can have more than one carousel on the page and style them differently,
  or reference a dom element via their unique id attribute name via javascript.
  This number is generated automatically in Carousel and passed in. */
  uid: number;
};

const CarouselOutfits = ({
  ariaLabelItems = [],
  currentSlide = 0,
  largeImages = [],
  mainImages = [],
  onClick,
  onKeyDown,
  onModelImages = [],
  selectedItem,
  uid,
  visibleSlides = 3,
}: CarouselOutfitsProps & PropsInjectedByCarousel) => {
  const isMobile = visibleSlides === 1;
  const isQuickView = visibleSlides === 4;
  const totalOfProducts = Math.max(mainImages.length, largeImages.length);
  const classNamesCarousel = [s.container, s.outfitsContainer];
  const classNamesSlider = [
    s.centeredSlider,
    styles.carouselSlider,
    isQuickView && styles.sliderQuickView,
  ];

  return (
    <CarouselProvider
      className={cn(classNamesCarousel)}
      data-testid="CarouselOutfits"
      data-uid={uid}
      currentSlide={currentSlide}
      hasMasterSpinner={false}
      lockOnWindowScroll
      naturalSlideHeight={isQuickView ? 900 : 990}
      naturalSlideWidth={900}
      totalSlides={mainImages.length}
      visibleSlides={visibleSlides}
    >
      <Slider
        className={cn(classNamesSlider)}
        classNameTrayWrap={styles.trayWrap}
      >
        <ImageWatcher images={mainImages} />
        {mainImages.map((mainImage, i) => (
          <RenderSlideOutfits
            ariaLabel={ariaLabelItems[i]}
            i={i}
            isMobile={isMobile}
            isQuickView={isQuickView}
            key={mainImages[i]}
            large={largeImages[i]}
            main={mainImages[i]}
            onClick={onClick}
            onKeyDown={onKeyDown}
            onModelImage={onModelImages[i]}
            selectedItem={selectedItem}
            totalOfProducts={totalOfProducts}
            uid={uid}
          />
        ))}
      </Slider>
      <div className={s.buttonsSlider}>
        <ButtonBack className={s.buttonBackDisabledHidden}>
          <IconLeft />
        </ButtonBack>
        <ButtonNext className={s.buttonNextDisabledHidden}>
          <IconRight />
        </ButtonNext>
      </div>
    </CarouselProvider>
  );
};
export default CarouselOutfits;
